export const EMPTY_WORK_COMPLEXITY = 15026
export const BORDER_WIDTH = 2
export const MINIMUM_FILE_SIZE = 103702
export const DELAY = 200
